import { HeroProps } from '../../components/hero-v2/hero'
import heroFallbackImage from '../../components/assets/fallback/hero-image.png'
import helpMeChooseFallbackImage from '../../components/assets/fallback/help-me-choose.png'
import whyCinchFallbackImage from '../../components/assets/fallback/why-cinch.png'
import partExFallbackImage from '../../components/assets/fallback/part-exchange.png'

import { ValuePropositionCardProps } from '../../components/value-propositions/value-propositions'
import { HelpMeChooseProps } from '../../components/help-me-choose/help-me-choose'
import { WhyCinchProps } from '../../components/why-cinch/why-cinch'
import { PartExchangeSectionProps } from '../../components/part-ex/part-ex'
import { TextLink } from '@cinch-labs/design-system'

export const fallbackHeroProps: HeroProps = {
  _uid: 'fallback-hero',
  storyFallback: true,
  component: 'HomeHeroV2',
  heading: 'Summer daily deals',
  isHeroPromotional: false,
  isMobileImageShown: true,
  starRating: 0,
  starRatingLabel: '',
  numberOfReviews: 0,
  totalStock: 0,
  subheading:
    '£250 - £1000 off selected cars, with 14 days to love it or your money back.',
  image: {
    _uid: 'hero-image',
    component: 'HomeImage',
    filename: heroFallbackImage,
    alt: 'Cinch hero fallback image',
  },
  heroLink: [
    {
      _uid: 'fallback-link',
      component: 'LinkWithText',
      label: 'Browse Cars',
      href: '/used-cars',
      variant: 'primary',
      link: {
        url: '/used-cars?tags=cars-on-offer',
        linktype: 'url',
        fieldtype: 'multilink',
        cached_url: '/used-cars?tags=cars-on-offer',
      },
      text: 'View cars on offer',
    },
  ],
  heroPartExchange: [
    {
      _uid: 'fallback-hero-part-exchange',
      component: 'HeroV2PartExchange',
      title: 'Get a free, instant part exchange quote',
      label: 'Enter your car registration',
      ctaText: 'Start your free valuation',
      placeholder: 'Eg. A20 FGG',
      partExTextList: [
        {
          _uid: '1',
          component: 'Text',
          text: 'Guaranteed price for your car',
        },
        {
          _uid: '2',
          component: 'Text',
          text: 'No hidden fees',
        },
        {
          _uid: '3',
          component: 'Text',
          text: 'We collect your part ex car',
        },
      ],
    },
  ],
  makes: [],
}

export const valuePropositionsFallBack: ValuePropositionCardProps[] = [
  {
    heading: 'cinch quality assured',
    body: (
      <p>
        All cars are{' '}
        <TextLink href="/car-inspection" key="car-inspection" target="_blank">
          carefully reconditioned
        </TextLink>{' '}
        and have a minimum of 6 months on the MOT.
      </p>
    ),
    icon: 'shield',
  },
  {
    heading: 'Caring for your car',
    body: (
      <p>
        Our cars come with a 90-day warranty with breakdown assistance. Add{' '}
        <TextLink href="/cinch-care" key="cinch-care" target="_blank">
          cinchCare
        </TextLink>{' '}
        for lifetime warranty, breakdown assistance and servicing from £34.99 a
        month.
      </p>
    ),
    icon: 'UnionShield',
  },
]

export const helpMeChooseFallback: HelpMeChooseProps = {
  title: 'Not sure what you are looking for?',
  heading: 'Let cinch help you choose',
  body: 'Try our nifty Help Me Choose tool. Answer a few simple questions and find your perfect match',
  ctaText: 'Help me choose',
  image: {
    _uid: 'help-me-choose',
    component: 'HomeImage',
    filename: helpMeChooseFallbackImage,
    alt: 'help-me-choose',
  },
}

export const whyCinchFallback: WhyCinchProps = {
  title: 'Why cinch?',
  image: {
    _uid: 'why-chinch',
    component: 'HomeImage',
    filename: whyCinchFallbackImage,
    alt: 'why-chinch',
  },
  cards: [],
  fallback: true,
}

export const partExFallback: PartExchangeSectionProps = {
  title: 'Part exchange?',
  subtitle: 'Get a free, instant part-ex quote.',
  label: 'Enter your car registration',
  placeholder: 'E.g. A20FGG',
  ctaText: 'Start your free valuation',
  image: {
    _uid: 'part-exchange',
    component: 'HomeImage',
    filename: partExFallbackImage,
    alt: 'part-exchange',
  },
  link: 'Find out more about part exchange',
}
